import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { UserRole } from './userrole';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-userrole-modal-update',
  templateUrl: './userrole-modal-update.component.html'
})
export class UserroleModalUpdateComponent extends BaseModalUpdateComponent<UserRole> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<UserRole>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) { 
    super(modalContainerService, activeModal,modalService);
  }
 


  ngOnInit() {
  }

}
